export { default } from 'react-bootstrap/ResponsiveEmbed';
